import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

/**
 *
 * @returns {Promise<object[]>}
 */

export const crearRequerimiento = async (requerimiento) => {
    try {
        const resp = await axios.post(
            `${API_URL}/requerimientos`,
            requerimiento,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const cerrarRequerimiento = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/requerimientos/cerrar`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

